import React, {Fragment, useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import {handleValidateObj} from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import {Button, Image} from "react-bootstrap";
import Images from "../../../assets/images/imageData";
import propTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import {toast, ToastContainer} from "react-toastify";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import {Link} from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import CardSection from 'components/sales/cardSection/cardSection';
// import './hoto.css';
import QrReader from 'modern-react-qr-reader'
import Regex from "../../../services/utils/regex/Regex";
import {saveMaterialReceive} from "../../../services/redux/installation/hardwareInstall/action";
import './materialui.css';

const MaterialReceiveForm = ({
                               history,
                               match,
                               imageUploadUrlPublic,
                               saveHotoMaintenance,
                               getHotoDetails,
                               hotoDetails,
                               allMaterialList,
                               getChallanItems,
                               challanLineItems,
                               getMateriaById,
                               getMaterial,
                               saveMaterialReceive
                             }) => {

  const [inputList, setInputList] = useState([{
    line_item_id: "",
    material_name: "",
    request_quantity: "",
    receive_quantity: "",
    photo: "",
    serial_no: [],
    scan_value: false
  }]);
  // console.log('type ' + JSON.stringify(inputList[0]?.serial_no));
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalMsg, setMessage] = useState('');
  const {baseUrl} = useContext(BaseUrl);
  const [materialList, setMaterialList] = useState([]);
  const [addMaterialModal, setAddMaterialModal] = useState(false);
  const [newMaterial, setNewMaterial] = useState();
  const [startScan, setStartScan] = useState([]);
  const [loadingScan, setLoadingScan] = useState(false);
  const [result, setResult] = useState("No result");
  const [extraMat, setExtraMat] = useState(false);
  const [storeReturn, setStoreReturn] = useState('');
  const [prodCat, setProdCat] = useState();
  const [matData, setMatData] = useState();
  const [checkState, setCheckState] = useState(false);
  const [challanDocument, setChallanDocument] = useState('');

  useEffect(() => {
    console.log(challanLineItems); 
    // return false;
    if (
      challanLineItems?.items !== undefined &&
      challanLineItems?.items !== null
    ) {
      // const matData = challanLineItems;
      setTimeout(() => {
        // if (challanLineItems != '') {
        setInputList(challanLineItems?.items);
        setCheckState(true);
        setProdCat(challanLineItems?.hardware_category);
        // }
      }, 100);
    }
  }, [challanLineItems]);

  useEffect(() => {
    if (allMaterialList !== undefined) {
      setMaterialList(allMaterialList);
    }
  }, [allMaterialList])


  useEffect(() => {
    (async () => await getChallanItems(match.params.id))();
  }, [getChallanItems]);

  // handle input change
  const handleInputChange = (value, index, field_name, max_value) => {
    const list = [...inputList];
    list[index][field_name] = value;
    setInputList(list);
  };
  const handledropDownChange = (e, index, name) => {
    const {value, id} = e;
    const list = [...inputList];
    list[index][name] = id;
    setInputList(list);
  };

  const handleImageChange = (index, val, name) => {
    const list = [...inputList];
    list[index][name] = val;
    setInputList(list);
  };

  const handleModalHide = async () => {
    setIsModal(false);
    history.push(`${baseUrl}/material-receiving`);
  };

  const handleMaterialModalHide = async () => {
    setAddMaterialModal(false);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list[index]['photo'] = '';
    setInputList(list);
  };

  const handleRemoveSerialNo = (item,key,index) => {
     const list = [...inputList];
     if(list[item] !== undefined && list[item][key] !== undefined){
      list[item][key].splice(index, 1);
     }
     setInputList(list);
  }

  const handleExtraMaterial = async (val) => {
    setExtraMat(val.id);
    setMatData();
    if (val.id === 'false') {
      setStoreReturn('');
    }
  };
  const handleStoreReturn = async (val) => {
    setStoreReturn(val.id);
  };
  const handleProductData = (val) => {
    setMatData(val);
  };

  const scanStart = (index) => {
    const list = [...inputList];
    list[index]['scan_value'] = !list[index]['scan_value'];
    setInputList(list);
  };

  const handleScan = (data, index) => {
    setLoadingScan(true);
    if (data) {
      const list = [...inputList];
      const newVal = [...list[index]['serial_no'], data];
      list[index]['serial_no'] = newVal;
      list[index]['scan_value'] = false;
      setInputList(list);
      setStartScan(false);
      setLoadingScan(false);
    }
    setLoadingScan(false);
  }
  const handleError = err => {
    console.error(err)
  }

  const handleSubmit = (id) => {
        setIsLoading(true);
      (async () => {
        var obj = {
          receive_data: inputList,
          mat_data: extraMat === 'true' ? matData?.productData : '',
          send_to_store: storeReturn,
          ts_id: id,
          challan_document:challanDocument,
        };
        const res = await saveMaterialReceive(obj);
          // console.log(res);
        if (res === true) {
          setMessage('Details saved successfully!');
          setIsModal(true);
        } else {
          // toast.error(res);
          // setMessage('Not Saved!');
          // setIsModal(true);
        }
      })();
        setIsLoading(false);

  };

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(match.params.id)} /* disabled={isClicked} */>
          {localization.submitDtl}
          {/*<Image fluid src={Images?.ArrowRight}/>*/}
        </Button>
      </Fragment>
    );
  };

  const handleCancelModalHide = () => {
    history.goBack();
  };

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      title={localization.goBack}
    >

      <FormSection title={localization.matReceiveForm}>
        {console.log(inputList)}
        {checkState && inputList && inputList.length > 0 &&
          <>
            {
              inputList.map((x, i) => {
                return (
                  <CardSection key={i}  title={x.material_name}>
                    <div key={i} className="row">
                      <div className="col-md-3">
                        <ConstantInput
                          label={'Requested Quantity'}
                          value={x?.request_quantity}
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-3">
                        <ConstantInput
                          label={'Received Quantity'}
                          type="number"
                          required
                          isStarRequired={true}
                          min={0}
                          // max={x?.request_quantity}
                          handleChange={value => handleInputChange(value, i, 'receive_quantity', x?.request_quantity)}
                          value={x?.receive_quantity}
                        />
                      </div>
                      <div className="col-md-3">
                        <FileUpload
                          id={"agreementContractUpload" + i}
                          accept=".png,.jpg,.jpeg"
                          documentUploadUrl={imageUploadUrlPublic}
                          onChange={(val) => handleImageChange(i, val, 'photo')}
                          showFileName={false}
                        >
                        <span className="btn btn-transparent">
                          {localization.image}
                          {/* <span className="label-star" style={{color: 'red'}}>
                            &nbsp; *
                          </span> */}
                        </span>
                        </FileUpload>
                      </div>

                      {x?.photo &&
                        <div className="col-md-3">
                          <div className="row img-div">
                            <div className="col-md-2">
                              {
                                x?.photo.split('.').pop() == 'png' ?
                                  <img src={x?.photo} style={{
                                    "width": "80px",
                                    "borderRadius": "16px",
                                    "height": "57px"
                                  }}/>
                                  :
                                  x?.photo.split('.').pop() === 'jpeg' ? <img src={x?.photo}
                                                                              style={{
                                                                                "width": "80px",
                                                                                "borderRadius": "16px",
                                                                                "height": "57px"
                                                                              }}/> :
                                    x?.photo.split('.').pop() === 'jpg' ? <img src={x?.photo}
                                                                               style={{
                                                                                 "width": "80px",
                                                                                 "borderRadius": "16px",
                                                                                 "height": "57px"
                                                                               }}/>
                                      :
                                      ""
                              }
                              <a className='remover' onClick={() => handleRemoveClick(i)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red"
                                     className="bi bi-x-circle" viewBox="0 0 16 16">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                  <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                              </a>
                            </div>
                          </div>
                        </div>
                      }

                      {/* <div className="col-md-3">
                        <Button onClick={() => scanStart(i)}>
                          {"Scan QR"}
                        </Button>
                      </div>

                      {x?.scan_value == true && (
                        <div className="col-md-3">
                          <QrReader
                            facingMode={"environment"}
                            delay={1000}
                            onError={handleError}
                            onScan={(data) => {
                              if (data) {
                                handleScan(data, i)
                              }
                            }}
                          />
                        </div>
                      )} */}

                      {/* <p>{x?.serial_no}</p> */}
                      {/* {inputList[i]?.serial_no && inputList[i]?.serial_no?.length > 0 ? (
                      <>  
                      <div className="row form-group">
                       {inputList[i]?.serial_no.map((val,j) => { 
                        return (
                        <div className="col-md-3 scanned-element d-inline-flex">
                          <div className='w90'>{val}</div>
                          <a className='remover cross' onClick={() => handleRemoveSerialNo(i,'serial_no',j)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red"
                                  className="bi bi-x-circle" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                          </a>
                        </div>
                       )
                       })}
                      </div>
                      </>
                      ):null} */}
                    </div>
                  </CardSection>
                );
              })
            }
          </>
        }
        <Fragment>
          <div className="row">
            <div className="col-md-12">
              <DropDownInput
                label={"Did you receive extra materials?"}
                data={[
                  {id: 'true', name: 'YES'},
                  {id: 'false', name: 'NO'},
                ]}
                required
                isStarRequired={true}
                getIdValue={(val) => {
                  handleExtraMaterial(val);
                }
                }
              />
            </div>
          </div>
          {extraMat === 'true' &&
            <div className="row">
              <div className="col-md-12">
                <DropDownInput
                  label={"Return to store?"}
                  data={[
                    {id: 'true', name: 'YES'},
                    {id: 'false', name: 'NO'},
                  ]}
                  required
                  isStarRequired={true}
                  getIdValue={(val) => {
                    handleStoreReturn(val);
                    // handledropDownChange(val, i, 'm_mat_status');
                  }
                  }
                  // value={x.status}
                />
              </div>
            </div>
          }
          {
            storeReturn !== '' &&
            <Inventory
              data={challanLineItems}
              handleProductData={handleProductData}
              getMaterial={getMaterial}
              getMateriaById={getMateriaById}
            />
          }
          <div className="col-md-12">
              <FileUpload
                id={"challanUpload"}
                accept=".png,.jpg,.jpeg"
                documentUploadUrl={imageUploadUrlPublic}
                onChange={(val) => setChallanDocument(val)}
                showFileName={false}
                required
                isStarRequired={true}
              >
              <span className="btn btn-transparent">
                {localization.challanDocument}
              </span>
              </FileUpload>
            </div>
        </Fragment>
      </FormSection>


      <br/>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt=""/>
          </div>
          <h5>{modalMsg}</h5>
          {/* <Link
            to={`${baseUrl}/material-receiving`}
            // to={history.goBack()}
            className="btn btn-primary mb-4"
          >
            Go to Listing
          </Link> */}

          <Button
            onClick={handleCancelModalHide}
            className="btn btn-primary mb-4"
          >
            Go to Listing
            <img src={Images?.ArrowRight} alt="" />
          </Button>

        </div>
      </ModalPop>

    </Layout>
  );
};
MaterialReceiveForm.propTypes = {
  data: PropTypes.any,
  history: propTypes.any,
};
export default MaterialReceiveForm;
